module.exports = __webpack_public_path__ + "img/level-pass.ba8e7d13.png";